import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Card, Popover, Button, Checkbox, Descriptions, message } from 'antd'
import { DownOutlined, UpOutlined } from '@ant-design/icons'
import moment from 'moment'
import mime from 'mime-types'
import Feather from '@sysunite/react-feather'
import { isUrl, downloadFile, getBooleanLabel, getNodeLabel, getProjectData, getRelationkeyLabel, getRenderedJson, getUid } from 'Services/WeaverUtils'
import ColorService from 'Services/ColorService'
import WeaverService from 'Services/WeaverService'
dateFormatString = 'MMM DD, YYYY'

export relationAttributesRenderer = (node) ->
  (getProjectData().relationAttributes or [])
  .filter(({ relKey }) -> node.relation(relKey).first()?)
  .map(({ relKey, renderFn }) ->
    renderFn ?= getNodeLabel
    {
      key: relKey
      label: <Tooltip title={relKey}>{ _.truncate(getRelationkeyLabel(relKey), { length: 25 }) }</Tooltip>
      value: node
        .relation(relKey)
        .all()
        .map((toNode) ->
          color = ColorService.getColorForNode(toNode)
          <Tooltip
            arrowPointAtCenter={true}
            placement="bottomLeft"
            title="This is a derived attribute (The attribute actually resides on #{ getNodeLabel(toNode ) }."
          >
            <Feather style={{ fill: color, color, marginRight: 5 }} type="circle" />
            <span>{ renderFn(toNode) }</span>
          </Tooltip>
        )
    }
  )

export NodeMetadata = ({ node }) ->

  [show, setShow] = useState(false)

  node ?= Weaver.Node.get()
  creator = WeaverService.currentProjectUsers[node._createdBy]

  title = (
    <>
      {
        if isUrl(getUid(node))
          <a target="_blank" href="#{node.id()}"><b>{ node.id() }</b></a>
        else
          <b style={{ color: 'var(--secondaryColor)' }}>{ node.id() }</b>
      }
      <Button
        onClick={->
          await navigator.clipboard.writeText(node.id())
          message.success('Copied to clipboard')
        }
        type="link"
        icon={<Feather type='copy' />}
      />
    </>
  )

  content = (
    <Descriptions
      layout='horizontal'
      size="small"
      column={1}
      className="attributes-container"
      style={{ maxWidth: 700 }}
    >
      <Descriptions.Item
        label="Graph"
        labelStyle={{ alignItems: 'center' }}
        contentStyle={{ alignItems: 'center' }}
      >
        <span>{ if node.getGraph()? then "#{ node.getGraph() }" else "Default" }</span>
        <Button
          onClick={->
            await navigator.clipboard.writeText(node.getGraph())
            message.success('Copied to clipboard')
          }
          type="link"
          icon={<Feather type='copy' />}
        />
      </Descriptions.Item>
      <Descriptions.Item label="Creator">
        { if creator then "#{ creator.firstname } #{ creator.lastname }" else "Unnamed" }
      </Descriptions.Item>
      <Descriptions.Item label="Created">
        { moment(node._createdAt).format(dateFormatString) }
      </Descriptions.Item>
    </Descriptions>
  )

  iconProps = {
    style: {
      fontSize: '10px',
      cursor: 'pointer'
    }
    onClick: -> setShow(!show)
  }

  <>
    <span style={{ display: 'inline-block', width: '80%' }}>
      {
        if node instanceof Weaver.RelationNode
          node.key
        else
          getNodeLabel(node)
      }
    </span>
    {
      show &&
        <Card
          headStyle={{ textAlign: 'center' }}
          style={{ margin: '15px' }}
          title={title}
          size="small"
        >
          { content }
        </Card>
    }
    <span
      style={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
      }}
    >
    {
      if show
        <UpOutlined { iconProps... }/>
      else
        <DownOutlined { iconProps... }/>
    }
    </span>
  </>

export getFormattedAttributeValue = (val, key, dataType, type) ->
  if dataType is 'json'
    getRenderedJson(val)
  else if val._isAMomentObject
    date = moment(val)
    if date.format('HH:mm') isnt '00:00'
      date.format("#{ dateFormatString } HH:mm")
    else
      date.format(dateFormatString)
  else if isUrl(val)
    if isImage(val)
      <Image className="attribute-image" width='100%' src={val} />
    else
      <a href={val} target="_blank">{val}</a>
  else if _.isBoolean(val)
    val = getBooleanLabel(key, val)
    <Checkbox checked={val} />
  else if dataType in ['fileId', 'wvr:fileId']
    <ConnectedDownloadLink value={val} />
  else if dataType is 'multiline'
    <span style={{ whiteSpace: 'pre-wrap' }}>{ val }</span>
  else
    val

isImage = (val) ->
  type = mime.lookup(val)
  type and type.startsWith('image')

export isDownloadable = (type, key, value) ->
  getProjectData().fileAttrMap?[type?.id()]?[key] and
    hasExtension(value)

hasExtension = (toTest) ->
  isValid = switch toTest.split?('.').pop()
    # supported fileTypes
    when 'doc'  then true
    when 'docx' then true
    when 'dwg'  then true
    when 'pdf'  then true
    when 'png'  then true
    when 'txt'  then true
    when 'xls'  then true
    when 'xlsx' then true

DownloadableLink = ({ value, files }) ->
  [file, setFile] = useState(undefined)

  useEffect( ->
    file = files.find((f) -> value is f.name() or value is f.id())
    setFile(file)
  , [value])

  <Link
    to="#"
    onClick={ -> downloadFile(file.id(), file.name())}
    disabled={!file}
  >
    { value }
  </Link>

ConnectedDownloadLink = connect(({ projects: { files } }) -> { files })(DownloadableLink)
